import { Action } from '@ngrx/store';
import { ConfigMW } from '../../interfaces/config.interface';

export const CONFIG_GET = 'cookie:CONFIG_GET';

export class GetConfigAction implements Action {
  readonly type = CONFIG_GET;

  constructor(readonly payload: ConfigMW) {}
}

export type Actions = GetConfigAction;
